import React from "react";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useSidebarFilters } from "../sidebar-filters";
import ToolbarButton from "./button";

const RefreshButton: React.FC = () => {
  const { search } = useSidebarFilters();
  const handleClick = () => {
    search();
  };
  return (
    <ToolbarButton
      className="RefreshButton"
      style={{
        boxShadow: "0 1px 2px 0 rgba(34,36,38,.07)",
      }}
      onClick={handleClick}
    >
      <RefreshIcon
        style={{
          fontSize: "24px",
          margin: "7px 0px 0px 7px",
          color: "#B6B6B6",
        }}
      />
    </ToolbarButton>
  );
};

export default RefreshButton;
